import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Download, Users, GraduationCap, Shield } from "lucide-react";
import { handleDownloadCSV } from "../../../controllers/controller.all";

export default function ExportUsers() {
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";
    const ecoleId = user?.ecole?._id || user?.ecole;

    const [loading, setLoading] = useState(false);

    const handleExport = async (type) => {
        await handleDownloadCSV(type, ecoleId, token, setLoading);
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Export des Utilisateurs</h1>
                    <p className="text-sm text-gray-500 mt-1">Exportez les données de vos utilisateurs au format CSV.</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex flex-col items-center justify-center text-center">
                    <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mb-4">
                        <GraduationCap className="h-8 w-8" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Étudiants</h3>
                    <p className="text-sm text-gray-500 mb-6">Exportez la liste de tous les étudiants de votre école avec leurs classes respectives.</p>
                    <button 
                        onClick={() => handleExport("students")}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                    >
                        <Download className="h-4 w-4" /> Exporter CSV
                    </button>
                </div>

                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex flex-col items-center justify-center text-center">
                    <div className="w-16 h-16 bg-green-50 text-green-600 rounded-full flex items-center justify-center mb-4">
                        <Users className="h-8 w-8" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Professeurs</h3>
                    <p className="text-sm text-gray-500 mb-6">Obtenez la liste complète du corps enseignant affilié à votre établissement.</p>
                    <button 
                        onClick={() => handleExport("teachers")}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition disabled:opacity-50"
                    >
                        <Download className="h-4 w-4" /> Exporter CSV
                    </button>
                </div>

                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex flex-col items-center justify-center text-center">
                    <div className="w-16 h-16 bg-purple-50 text-purple-600 rounded-full flex items-center justify-center mb-4">
                        <Shield className="h-8 w-8" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Administrateurs</h3>
                    <p className="text-sm text-gray-500 mb-6">Téléchargez la liste des administrateurs ayant accès à la gestion de l'école.</p>
                    <button 
                        onClick={() => handleExport("admins")}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition disabled:opacity-50"
                    >
                        <Download className="h-4 w-4" /> Exporter CSV
                    </button>
                </div>
            </div>
        </div>
    );
}
